import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { queryClient } from './providers/query';
import { AppRouter } from './providers/router';
import './styles/index.scss';

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('ru');
  }, [i18n]);

  return (
    <Suspense>
      <QueryClientProvider client={queryClient}>
        <AppRouter />

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Suspense>
  );
};

export default App;
